import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/eLabel/importer/eLabelImporterSelectors';
import { importCSV } from 'src/modules/eLabel/eLabelService';
import fields from 'src/modules/eLabel/importer/eLabelImporterFields';
import { i18n } from 'src/i18n';

const eLabelImporterActions = importerActions(
  'ELABEL_IMPORTER',
  selectors,
  importCSV,
  fields,
  i18n('entities.eLabel.importer.fileName'),
);

export default eLabelImporterActions;
